import ToppingSidebar from '../ToppingSidebar/topping-sidebar';

export default ToppingSidebar;